/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-list-ite[_ngcontent-%COMP%]{background:#d2cfcf}.mat-list-item[_ngcontent-%COMP%]:hover{background:#f2f2f2}"];
export { styles as styles };
